/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './InputErrorText.style';

type Props = {
  layoutClass?: string,
  children: React.Node,
  // Self passed
};

const useStyles = createUseStyles(styles);

const InputErrorText = ({ layoutClass, children }: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <small className={classNames(classes.root, layoutClass)}>{children}</small>
  );
};

export default InputErrorText;
